module.exports = __webpack_public_path__ + "img/company_address-18.f65c903d.svg";